<template>
  <div
    v-if="description.constructor !== Array"
    class="wine-description-container"
  >
    <div class="description-container">
      <div
        class="wine-description-text"
        v-html="description"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-details-description',
  props: {
    'description': {
      type: [String, Array],
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.wine-description-container {
  .description-container {
    display: flex;
    flex-wrap: nowrap;

   ::v-deep .wine-description-text {
      color: var(--main-product-detail-text-color);
    }
  }
}
</style>
